const API_URL = "https://echoecommercewebsite.onrender.com"; 

export default API_URL;
